import React, { useEffect, useState } from "react";
import SkincareTrackerComponent from "../../components/skincare-tracker/SkincareTrackerComponent";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getSkincareTrackerApi } from "../../services/skinTracker.service";
import PageLoader from "../../components/common/loader/pageLoader";
import dayjs from "dayjs";
import { useAppSelector } from "../../hooks/reduxHooks";


interface SkincareTrackerContainerInterface {}

interface SkincareProduct {
  product_id: number;
  [key: string]: any;
}

interface SkincareTrackerData {
  skincare_data: SkincareProduct[];
  [key: string]: any;
}
const SkincareTrackerContainer = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<SkincareTrackerData | undefined>();
  const profile = useAppSelector((state) => state?.profile);
  const { survey_id } = profile;
  useEffect(() => {
    setLoading(true);
    if(survey_id) {
      fetchSkincareTrackerData();
    }
  }, [survey_id]);

  const fetchSkincareTrackerData = () => {
    dispatch(
      getSkincareTrackerApi({
        survey_id: survey_id,
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          setData(data);
        },
        unAunthenticatedCallback: () => {
          // handle unauthenticated case here if needed
        },
      })
    );
  };

  const updateSkincareTrackerData = (
    productId: number,
    field: string,
    value: any
  ) => {
    setData((prevData: SkincareTrackerData | undefined) => {
      if (!prevData || !prevData.skincare_data) return prevData;

      const updatedSkincareData = prevData.skincare_data.map(
        (product: SkincareProduct) => {
          if (product.product_id === productId) {
            let updatedValue = value;

            // Handle date formatting for API
            if (field === "start_date" || field === "expire_date") {
              updatedValue = value ? dayjs(value).format("YYYY-MM-DD") : null;
            }

            return { ...product, [field]: updatedValue };
          }
          return product;
        }
      );

      return {
        ...prevData,
        skincare_data: updatedSkincareData,
      };
    });
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <SkincareTrackerComponent
      data={data}
      updateProduct={updateSkincareTrackerData}
    />
  );

};

export default SkincareTrackerContainer;
